import React from 'react'

const Position = () => {
    return (
        <div className="position-div" data-aos="fade-in" data-aos-duration="2000">
            <div className="position-imfo">
                <div className="position">
                    <h4><span>Developer Student Club AKGEC</span></h4>
                    <p>Web Developer</p>
                    <p>2020 - present</p>
                </div>
                <div className="position">
                    <h4><span>Developer At Team Conatus</span></h4>
                    <p>Technical Society of AKGEC</p>
                    <p>2020 - present</p>
                </div>
            </div>
        </div>
    )
}

export default Position
